function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M17.002 1.996a5.002 5.002 0 110 10.004 5.002 5.002 0 010-10.004",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M20.003 14.001v.375a2.834 2.834 0 01-2.834 2.834h-4.724l-4.724 3.78v-3.78h-1.89a2.834 2.834 0 01-2.835-2.834V6.817A2.834 2.834 0 015.83 3.983H10M18.36 6.942a.054.054 0 00-.057.056.056.056 0 10.055-.056M15.644 6.942a.056.056 0 10.003 0",
  stroke: "currentColor",
  strokeWidth: 1.5,
  strokeLinecap: "round",
  strokeLinejoin: "round"
});

function SvgSupportChat(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2);
}

export default SvgSupportChat;